module.exports = __webpack_public_path__ + "static/007502-f9045fb4e16875097ca7c0ea46cbd5f4.jpg";